var exports = {
  "kL": "xdbfd91f1--1679d8--container",
  "DD": "xdbfd91f1--1679d8--title",
  "ZQ": "xdbfd91f1--1679d8--items-container",
  "aj": "xdbfd91f1--1679d8--infrastructure-item",
};

module.exports = exports;
